import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3cbd5f0b&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.scss?vue&type=style&index=0&id=3cbd5f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd5f0b",
  null
  
)

export default component.exports